import React, { useState } from 'react';
import { createPayment } from '../Api/payments';
import './DentApp.css'

const BuyButton = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [email, setEmail] = useState('');

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleSelectSubscription = async (amount, description) => {
        if (!email.trim()) {
            setError('Введите email');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const paymentUrl = await createPayment(amount, 'RUB', description, email);
            window.location.href = paymentUrl;
        } catch (err) {
            setError('Не удалось создать платеж. Попробуйте снова.');
            console.error(err);
        } finally {
            setLoading(false);
            closeModal();
        }
    };

    return (
        <>
            <div className='roboto-condensed-1 btn_buy_m' onClick={openModal}>Купить</div>
            {isModalOpen && (
                <div className="modal_cntr">
                    <div className="modal-content" style={{alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
                        <h2>Выберите подписку</h2>
                        <input
                            type="email"
                            className="email-input"
                            placeholder="Введите email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        {error && <p className="error-text">{error}</p>}
                        <div className="subscription-options">
                            <button
                                className="subscription-btn"
                                onClick={() => handleSelectSubscription(5000, 'Подписка на 1 год')}
                                disabled={loading}
                            >
                                {loading ? 'Загрузка...' : '1 год – 5000 руб'}
                            </button>
                            <button
                                className="subscription-btn"
                                onClick={() => handleSelectSubscription(45000, 'Подписка навсегда')}
                                disabled={loading}
                            >
                                {loading ? 'Загрузка...' : 'Навсегда – 45000 руб'}
                            </button>
                        </div>
                        <button className="close-btn" onClick={closeModal}>Отмена</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default BuyButton;